/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard
 * (C) Copyright IBM Corp. 2014, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define({
	'dlg_loading': 'Bezig met laden...',
	'dlg_close': 'Sluiten',
	'dlg_ok': 'OK',
	'dlg_cancel': 'Annuleren',
	'dlg_back': 'Teruggaan',

	// Slider
	'sliderRegionLabel': 'Schuifregelaar - met de rechter en linker cursortoetsen verplaatst u de handvatten van de schuifregelaar',
	'sliderHandleLabel': 'Handvat van schuifregelaar',
	'a11ySliderHandleLabel': 'Handvat van schuifregelaar %{sliderValue}',
	'sliderInputLabel': 'waarde',

	// Side bar
	'sidebarAdd': 'Toevoegen',
	'clearTextFilterValue': 'Verwijderen',
	'missingDataSetData': 'De gegevens voor deze gegevensset zijn niet beschikbaar. Vernieuw de gegevensset of vraag de beheerder om toegang tot de bron.',

	// Toolbar
	'toolbarRegionLabel': 'Werkbalk',
	'toolbarLabel': '%{labelName}:',
	'toolbarNoValueLabel': '%{labelName}',
	//TextToolbar
	'fontSelect': 'Letterfamilie',
	'fontSizeSelect': 'Lettergrootte',
	'bold': 'Vet',
	'italic': 'Cursief',
	'underline': 'Onderstrepen',
	'justifyLeft': 'Links uitlijnen',
	'justifyCenter': 'Centreren',
	'justifyRight': 'Rechts uitlijnen',
	'insertOrderedList': 'Geordende lijst',
	'insertUnorderedList': 'Niet-geordende lijst',
	'fontColorPicker': 'Kleurenselector',
	'textWrap': 'Tekst laten doorlopen',
	'restore': 'Standaardwaarden herstellen',
	// Top Bottom
	'topbottomNumberOfResultsLabel': 'Aantal resultaten',
	'topbottomPercentLabel': 'Percentage',
	'topbottomNumberOfResultsLimit': 'De waarde kan %{lower} - %{higher} zijn',
	'topbottomSelectOption': 'Optie voor hoogste of laagste',
	'topbottomOptionLabel': 'Weergeven',
	'searchByLabel': 'Op',
	'searchNoMatches': 'Geen overeenkomsten gevonden',
	'topbottomRankColumnLabel': 'Een kolom voor rangorde toevoegen aan de tabel',
	'topbottomNone': 'Geen',
	'topCount': 'Hoogste aantal',
	'topPercent': 'Bovenste %',
	'bottomCount': 'Laagste aantal',
	'bottomPercent': 'Onderste %',
	'searchColumn': 'Een kolom zoeken',
	'searchColumnAriaLabel': 'Een kolom zoeken. Typ de naam van de kolom om te zoeken en gebruik vervolgens de pijl omlaag om de kolom in een lijst op te zoeken',
	'rankColumnLabel': 'Rangorde (%{columnLabel})',
	'topbottomClearLabel': 'Verwijderen',

	// Format
	'formatAuto': 'Automatisch',
	'formatConvertPercent': 'Decimaal converteren naar percentage',
	'formatAbbreviate': 'Afkorten',
	'formatUseGrouping': 'Scheidingsteken voor duizendtallen gebruiken',
	'dateStyle': 'Datumstijl',
	'dateTimeStyle': 'Datum/tijd-stijl',
	'formatMissingValueCharactersInfo': 'Ontbrekende waarden zijn de tekens die moeten worden afgebeeld als de waarde ontbreekt.',
	'currencySymbolLabel': 'Valutateken',
	'customSymbolPlaceholder': 'Een symbool toevoegen',
	'customSymbolLabelInfo': 'Geeft een of meer tekens aan die worden gebruikt als aangepast symbool. Dit symbool staat vóór het bedrag en eventuele andere tekens.',
	'numberLabel': 'Nummerlabel',
	'numberPositionLabel': 'Labelpositie',
	'numberLabelInfo': 'Geeft een label aan voor het ingedeelde getal dat als prefix of suffix wordt geplaatst, afhankelijk van de positie van het label.',
	'nullValueDefault': '<standaard>',
	'nullValueContent': '(geen waarde)',
	'default': 'Standaardwaarde',
	'beginning': 'Begin',
	'end': 'Eind',

	// More data indicator
	'moreDataIndicator': 'Uw gegevens zijn afgekapt tot %{threshold} items. Pas een filter toe om minder af te beelden.',

	// Expanded View / Focus mode
	'evCollapse': 'Samenvouwen',
	'duplicate': 'Dupliceren',
	'copyOf': 'Kopie van %{name}',
	'unableToDuplicateBoard': '"%{name}" kan niet worden gedupliceerd.',

	// Widget list
	'errorLoadingWidgetList': 'We kunnen de objecten niet laden',

	// Custom widgets
	'customWidget': 'Aangepaste widget'
});
